import { render } from "./StageRoute.vue?vue&type=template&id=01640ffe&scoped=true"
import script from "./StageRoute.vue?vue&type=script&lang=js"
export * from "./StageRoute.vue?vue&type=script&lang=js"

import "./StageRoute.vue?vue&type=style&index=0&id=01640ffe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01640ffe"]])

export default __exports__